module.exports = __webpack_public_path__ + "img/16.b714e4a3.png";